import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { FaFileExcel } from 'react-icons/fa';

const ImprimirExcel = ({ headers, rows, filters, titlePdf, empresa }) => {
  const [loading, setLoading] = useState(false);

const handleImprimir = () => {
  if (!rows || rows.length === 0) {
    alert("No hay datos para exportar.");
    return;
  }

  setLoading(true);

  setTimeout(() => {
    // 1️⃣ Columnas desde headers
    const columnFields = headers.map(h => h.field);
    const headerRow = ['N°', ...headers.map(h => h.headerName)];

    // 2️⃣ Filas desde rows
    const dataRows = rows.map((row, index) => [
      index + 1,
      ...columnFields.map(field => row[field] ?? '')
    ]);

    // 3️⃣ Encabezado
    const encabezado = [];
    if (empresa) encabezado.push([empresa.nombre_sitio]);
    encabezado.push([titlePdf || 'REPORTE']);

    // 4️⃣ Filtros
    const filterRows = filters?.length
      ? filters
          .filter(f => f.valor !== null && f.valor !== undefined && f.valor !== '')
          .map(f => [f.descripcion, f.valor])
      : [];

    const emptyRow = [[]];

    // 5️⃣ Data final
    const data = [
      ...encabezado,
      emptyRow,
      ...filterRows,
      emptyRow,
      headerRow,
      ...dataRows,
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Merges encabezado
    const mergeLength = headerRow.length - 1;
    worksheet['!merges'] = [];

    if (empresa) {
      worksheet['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: mergeLength } });
      worksheet['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 1, c: mergeLength } });
    } else {
      worksheet['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: mergeLength } });
    }

    // Ancho columnas
    worksheet['!cols'] = headerRow.map(() => ({ wch: 20 }));

    // Autofiltro
    const headerRowIndex =
      encabezado.length + 1 + filterRows.length + 1;

    worksheet['!autofilter'] = {
      ref: XLSX.utils.encode_range({
        s: { r: headerRowIndex, c: 0 },
        e: { r: headerRowIndex, c: mergeLength },
      }),
    };

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

    XLSX.writeFile(workbook, "reporte.xlsx");

    setLoading(false);
  }, 300);
};



  return (
    <>
      <button
        onClick={handleImprimir}
        title="Exportar a Excel"
        style={{
          backgroundColor: loading ? '#94d3a2' : '#1c9341',
          border: '1px solid #c6f6d5',
          borderRadius: '6px',
          padding: '6px 10px',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'background-color 0.3s ease',
          color: 'white',
        }}
        disabled={loading}
        onMouseEnter={e => {
          if (!loading) e.currentTarget.style.backgroundColor = '#15782f';
        }}
        onMouseLeave={e => {
          if (!loading) e.currentTarget.style.backgroundColor = '#1c9341';
        }}
      >
        <FaFileExcel size={18} color="white" />
        <span style={{ fontSize: 13 }}>
          {loading ? 'Exportando...' : 'Excel'}
        </span>
      </button>

    </>
  );
};

export default ImprimirExcel;
